import { FC, memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import person from '@/assets/icons/generals/person.svg';
import arrow from '@/assets/icons/multicalendar/arrow.svg';

import {
  Property as PropertyType,
  PropertyGrouped,
  PropertyGroupedClosed,
} from '@/services/Property/types';

import { useUpdateReservation } from '@/context/UpdateReservationContext';

import {
  Container,
  ContainerGrouped,
  ContainerProperty,
  ContentRow,
  Grouped,
  ModalProperty,
  Property,
  PropertyDesc,
  PropertyImage,
  PropertyTitle,
  PropertyUser,
} from './styles';

type Props = {
  className?: string;
  groupedData: PropertyGrouped[];
  propertyGroupedClosed: PropertyGroupedClosed;
  setPropertyGroupedClosed(categories: PropertyGroupedClosed): void;
  totalPropertiesLoaded?: number;
  totalPropertiesExists?: number;
  lastPropertyCode?: string;
};

const Properties: FC<Props> = ({
  groupedData,
  propertyGroupedClosed,
  setPropertyGroupedClosed,
  className,
}) => {
  const setCloseGroup = (groupId: string | number) => () => {
    setPropertyGroupedClosed({
      ...propertyGroupedClosed,
      [groupId]: !propertyGroupedClosed[groupId],
    });
  };
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [nameOwner, setNameOwner] = useState<string>('');
  const [nameHost, setNameHost] = useState<string>('');
  const [modalId, setModalId] = useState<string>('');
  const { reloadLoadingShimmer } = useUpdateReservation();
  const [loading, setLoading] = useState<boolean>(false);

  const handleHover = (e: any, host: string, owner: string, id: string) => {
    setModalId(id);
    setNameOwner(owner);
    setNameHost(host);
    setOpenModal(true);
  };

  useEffect(() => {
    setLoading(reloadLoadingShimmer);
  }, [reloadLoadingShimmer]);

  return (
    <>
      <Container className={className} loading={loading}>
        {groupedData.map((grouped) => (
          <ContainerGrouped
            key={`left-bar-${grouped.name}-${uuid()}-${grouped.id}`}
            expanded={!propertyGroupedClosed[grouped.id]}
          >
            <Grouped
              onClick={setCloseGroup(grouped.id)}
              expandIcon={<img className="arrow" src={arrow} alt="arrow" />}
            >
              <p className="category-grouped">{`${grouped.name} ? (${grouped.data.length})`}</p>
            </Grouped>
            <ContainerProperty>
              {grouped.data.map((property: PropertyType, index: number) => (
                <>
                  <ModalProperty
                    id={`modal-${property.id}`}
                    openModal={openModal && `modal-${property.id}` === modalId}
                  >
                    <ContentRow>
                      <p>Proprietário</p>
                      <span>{nameOwner}</span>
                    </ContentRow>
                    <ContentRow>
                      <p>Anfitrião</p>
                      <span>{nameHost}</span>
                    </ContentRow>
                  </ModalProperty>
                  <Link
                    onMouseEnter={(e: any) =>
                      handleHover(
                        e,
                        property?.host?.user?.trading_name
                          ? property?.host?.user?.trading_name || 'Não informado'
                          : `${property?.host?.user?.first_name || 'Não informado'} ${property?.host?.user?.last_name || ''}`,
                        property?.owners[0]?.user?.trading_name
                          ? `${property?.owners[0]?.user?.trading_name || 'Não informado'}`
                          : `${property?.owners[0]?.user?.first_name || 'Não informado'} ${property?.owners[0]?.user?.last_name || ''}`,
                        `modal-${property.id}`,
                      )
                    }
                    onMouseLeave={() => setOpenModal(false)}
                    key={`-${property.code}-${uuid()}`}
                    to={`/propriedades`}
                    state={{ title: 'Calendário', path: '/multicalendar' }}
                  >
                    <Property
                      key={`left-bar-${grouped.name}-${uuid()}-${property.code}`}
                      thisLastProperty={grouped.data.length - 1 === index}
                      id={`property-${property.code}`}
                    >
                      <PropertyImage
                        backgroundImage={property.img_url}
                        className="property-image"
                      />
                      <PropertyDesc>
                        <PropertyTitle className="property-code">{property.code}</PropertyTitle>
                        <div className="person-infos">
                          <img
                            src={person}
                            alt={property?.owners[0]?.user?.first_name || 'Não informado'}
                          />
                          <PropertyUser
                            title={
                              property?.owners[0]?.user?.trading_name.length > 2
                                ? `${property?.owners[0]?.user?.trading_name || 'Não informado'}`
                                : `${property?.owners[0]?.user?.first_name || 'Não informado'} ${property.owners[0]?.user?.last_name || ''}`
                            }
                          >
                            {` ${property?.owners[0]?.user?.trading_name ? property?.owners[0]?.user?.trading_name || 'Não informado' : `${property?.owners[0]?.user?.first_name || 'Não informado'} ${property?.owners[0]?.user?.last_name || ''}`}`}
                          </PropertyUser>
                        </div>
                      </PropertyDesc>
                    </Property>
                  </Link>
                </>
              ))}
            </ContainerProperty>
          </ContainerGrouped>
        ))}
      </Container>
    </>
  );
};

export default memo(Properties);
